import { Spin as AntSpin } from "antd";
import type { SpinProps as AntSpinProps } from "antd";

export interface SpinProps extends AntSpinProps {
  children?: React.ReactNode;
}

export function Spin({ children, ...props }: SpinProps) {
  return <AntSpin {...props}>{children}</AntSpin>;
}
